import ShareholdersSelect from './container';

export default ShareholdersSelect;
